import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { API_KEY, GoogleSheetsDbService } from 'ng-google-sheets-db';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { ReserveComponent } from './presentational/reserve/reserve.component';
import { FlightsComponent } from './presentational/flights/flights.component';
import { BourbonComponent } from './presentational/bourbon/bourbon.component';
import { IrishComponent } from './presentational/irish/irish.component';
import { ScotchComponent } from './presentational/scotch/scotch.component';
import { JapaneseComponent } from './presentational/japanese/japanese.component';
import { RyeComponent } from './presentational/rye/rye.component';
import { AmericanComponent } from './presentational/american/american.component';
import { OtherComponent } from './presentational/other/other.component';
import { SidebarComponent } from './presentational/sidebar/sidebar.component';
import { WhiskeyListComponent } from './shared/components/whiskey-list/whiskey-list.component';
import { BitesComponent } from './presentational/bites/bites.component';
import { DrinkForACauseComponent } from './presentational/drink-for-a-cause/drink-for-a-cause.component';
import { BarrelPickComponent } from './presentational/bottle-pick/barrel-pick.component';

@NgModule({
  declarations: [
    AppComponent,
    ReserveComponent,
    FlightsComponent,
    BourbonComponent,
    IrishComponent,
    ScotchComponent,
    JapaneseComponent,
    RyeComponent,
    AmericanComponent,
    OtherComponent,
    SidebarComponent,
    WhiskeyListComponent,
    BitesComponent,
    DrinkForACauseComponent,
    BarrelPickComponent,
  ],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
  ],
  exports: [],
  providers: [
    {
      provide: API_KEY,
      useValue: 'AIzaSyDwbtnnAixbs3qZd5hh5N4hYbqZT5fXUgw',
    },
    GoogleSheetsDbService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
